import { PrivacyAndSafetyScreenNavigationProps } from "./types"
import React from "react"
import PrivacyAndSafety from "./privacy-and-safety-screen"
import { PageRoot } from "~screens/page-root"


const PrivacyAndSafetyScreen: React.FC<PrivacyAndSafetyScreenNavigationProps> = () => {
  return (
    <PageRoot>
      <PrivacyAndSafety />
    </PageRoot>
  )
}

export default PrivacyAndSafetyScreen
